import AuthService from '@/shared/services/AuthService';
import { emptyMapping } from './mappingUtils';
// Kept per browser tab, so the work survives opening another screen (e.g. from the readiness report) and coming back.
const storageKey = () => `CapacityPlanningWizard-${AuthService.getTenantId()}`;
export const readStoredWizard = () => {
    try {
        const stored = sessionStorage.getItem(storageKey());
        if (!stored)
            return null;
        const wizard = JSON.parse(stored);
        return Object.assign(Object.assign({}, wizard), { mapping: Object.assign(Object.assign({}, emptyMapping), wizard.mapping) });
    }
    catch (_a) {
        return null;
    }
};
export const storeWizard = (wizard) => sessionStorage.setItem(storageKey(), JSON.stringify(wizard));
